module.exports = __webpack_public_path__ + "static/media/icon-2.93e2654f.png";